module.exports = __webpack_public_path__ + "static/media/Slide13.5a930c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide13.png
// module id = 1635
// module chunks = 0